import { useCurrentOrganizationContext } from "@/contexts";
import { CapabilitySet, EMPTY_CAPABILITY_SET } from "@/types/capability.types";

/**
 * Capability set the current user holds on the active organization. The
 * provider fetches it with the current platform's id, so the set is
 * pair-scoped to the `(current platform, organization)` pair — a grant held at
 * another platform the org is attached to does not surface, and the set
 * refetches on platform switch. Empty in platform-only mode, while the org is
 * unresolved, or when the BE has not shipped the `capabilities` field yet —
 * under strict RBAC an empty set denies (fail closed).
 */
export const useOrganizationCapabilities = (): CapabilitySet => {
  const { organization } = useCurrentOrganizationContext();
  return organization?.capabilities ?? EMPTY_CAPABILITY_SET;
};
